import firebase from "datastore/database";

const logError = async (businessUid, data) =>
  firebase
    .firestore()
    .collection(`error-log/business/${businessUid}`)
    .add(data);

export default logError;
